import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

/**
 * Reusable BackButton component for consistent navigation
 * Used across Admin, Setup, and any full-page flows
 */
const BackButton = ({ to = '/dashboard', label = 'Back to Dashboard', className = '' }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(to);
  };

  return (
    <button
      onClick={handleClick}
      className={`inline-flex items-center gap-2 text-sm font-medium text-cockpit-text-secondary hover:text-airbus-blue transition-colors duration-150 ${className}`}
      data-testid="back-button"
    >
      <ArrowLeft className="w-4 h-4" />
      <span>{label}</span>
    </button>
  );
};

export default BackButton;
